module.exports = __webpack_public_path__ + "static/media/russia.6e8cc30d.svg";